import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "white-space"
    }}>{`white-space`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`  UXP v3.0`}</p>
    <p>{`Determines how white space is handled. Supports `}<inlineCode parentName="p">{`wrap`}</inlineCode>{` (default), `}<inlineCode parentName="p">{`nowrap`}</inlineCode>{`, `}<inlineCode parentName="p">{`pre`}</inlineCode>{`, `}<inlineCode parentName="p">{`pre-line`}</inlineCode>{`, and `}<inlineCode parentName="p">{`pre-wrap`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/white-space"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/white-space`}</a></p>
    <p><strong parentName="p">{`Example`}</strong>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    white-space: pre;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      